import i18n from "@/services/i18n";

export default {
  0: {
    name: i18n.t("utilsData.statuses.bids.0"),
  },
  10: {
    name: i18n.t("utilsData.statuses.bids.10"),
  },
  20: {
    name: i18n.t("utilsData.statuses.bids.20"),
  },
  30: {
    name: i18n.t("utilsData.statuses.bids.30"),
  },
  40: {
    name: i18n.t("utilsData.statuses.bids.40"),
  },
  50: {
    name: i18n.t("utilsData.statuses.bids.50"),
  },
  51: {
    name: i18n.t("utilsData.statuses.bids.51"),
  },
  52: {
    name: i18n.t("utilsData.statuses.bids.52"),
  },
  200: {
    name: i18n.t("utilsData.statuses.bids.200"),
  },
  6: {
    name: i18n.t("utilsData.statuses.bids.6"),
  },
  7: {
    name: i18n.t("utilsData.statuses.bids.7"),
  },
  // Documents statuses
  // 10: {
  //     name: "Не загружен"
  // },
  11: {
    name: i18n.t("utilsData.statuses.bids.11"),
  },
  12: {
    name: i18n.t("utilsData.statuses.bids.12"),
  },
  13: {
    name: i18n.t("utilsData.statuses.bids.13"),
  },
  14: {
    name: i18n.t("utilsData.statuses.bids.14"),
  },
  // SMS report statuses
  sms: {
    1: { name: i18n.t("utilsData.statuses.sms.1") },
    2: {
      name: i18n.t("utilsData.statuses.sms.2"),
    },
    3: {
      name: i18n.t("utilsData.statuses.sms.3"),
    },
  },
  // CALL center
  call: {
    101: { name: i18n.t("utilsData.statuses.call.101") },
    102: { name: i18n.t("utilsData.statuses.call.102") },
    103: { name: i18n.t("utilsData.statuses.call.103") },
    104: { name: i18n.t("utilsData.statuses.call.104") },
    105: { name: i18n.t("utilsData.statuses.call.105") },
    1: { name: i18n.t("utilsData.statuses.call.1") },
    2: { name: i18n.t("utilsData.statuses.call.2") },

    // fucking painful fix
    /* 1: {
            name: "В работе"
        },
        2: {
            name: "На рассмотрении"
        },*/
    3: {
      name: i18n.t("utilsData.statuses.call.3"),
    },
    4: {
      name: i18n.t("utilsData.statuses.call.4"),
    },
    5: {
      name: i18n.t("utilsData.statuses.call.5"),
    },
  },
  bank: {
    1: {
      name: i18n.t("utilsData.statuses.bank.1"),
    },
    20: {
      name: i18n.t("utilsData.statuses.bank.20"),
    },
    30: {
      name: i18n.t("utilsData.statuses.bank.30"),
    },
    35: {
      name: i18n.t("utilsData.statuses.bank.35"),
    },
    40: {
      name: i18n.t("utilsData.statuses.bank.40"),
    },
    50: {
      name: i18n.t("utilsData.statuses.bank.50"),
    },
    51: {
      name: i18n.t("utilsData.statuses.bank.51"),
    },
    52: {
      name: i18n.t("utilsData.statuses.bank.52"),
    },
    60: {
      name: i18n.t("utilsData.statuses.bank.60"),
    },
    70: {
      name: i18n.t("utilsData.statuses.bank.70"),
    },
    130: {
      name: i18n.t("utilsData.statuses.bank.130"),
    },
    150: {
      name: i18n.t("utilsData.statuses.bank.150"),
    },
    160: {
      name: i18n.t("utilsData.statuses.bank.160"),
    },
    170: {
      name: i18n.t("utilsData.statuses.bank.170"),
    },
    180: {
      name: i18n.t("utilsData.statuses.bank.180"), //пока без подписи "Предложение банка принято и подписано"
    },
    200: {
      name: i18n.t("utilsData.statuses.bank.200"),
    },
  },
  package: {
    1: {
      name: i18n.t("utilsData.statuses.package.1"), // статус 1, но он всегда 1, даже когда не загружен
    },
  },

  invest: {
    1: {
      name: i18n.t("utilsData.statuses.invest.1"),
    },
    2: {
      name: i18n.t("utilsData.statuses.invest.2"),
    },
    3: {
      name: i18n.t("utilsData.statuses.invest.3"),
    },
    4: {
      name: i18n.t("utilsData.statuses.invest.4"),
    },
  },
  investSubtype: {
    1: {
      name: i18n.t("utilsData.statuses.investSubtype.1"),
    },
    2: {
      name: i18n.t("utilsData.statuses.investSubtype.2"),
    },
    3: {
      name: i18n.t("utilsData.statuses.investSubtype.3"),
    },
  },
  investUserDefault: {
    1: {
      name: i18n.t("utilsData.statuses.investUserDefault.1"),
      color: "yellow",
      textColor: "black",
    },
    10: {
      name: i18n.t("utilsData.statuses.investUserDefault.10"),
      color: "orange",
      textColor: "black",
    },
    30: {
      name: i18n.t("utilsData.statuses.investUserDefault.30"),
      color: "green",
      textColor: "white",
    },
    40: {
      name: i18n.t("utilsData.statuses.investUserDefault.40"),
      color: "red  lighten-2",
      textColor: "white",
    },
    100: {
      name: i18n.t("utilsData.statuses.investUserDefault.100"),
      color: "green darken-4",
      textColor: "white",
    },
  },

  investStatus: {
    0: { name: i18n.t("utilsData.statuses.investStatus.0"), color: "grey" },
    10: { name: i18n.t("utilsData.statuses.investStatus.10"), color: "orange" },
    30: { name: i18n.t("utilsData.statuses.investStatus.30"), color: "red" },
    40: { name: i18n.t("utilsData.statuses.investStatus.40"), color: "green" },
  },

  investRating: {
    10: {
      name: "D",
      color: "deep-orange darken-4",
      avatar_color: "deep-orange lighten-3",
      text: "white",
    },
    20: {
      name: "DD",
      color: "deep-orange darken-1",
      avatar_color: "deep-orange lighten-2",
      text: "white",
    },
    30: {
      name: "DDD",
      color: "deep-orange lighten-1",
      avatar_color: "deep-orange lighten-3",
      text: "white",
    },

    60: {
      name: "CCC",
      color: "grey lighten-2",
      avatar_color: "grey lighten-1",
    },

    70: {
      name: "B-",
      color: "yellow darken-4",
      avatar_color: "lime darken-4",
      text: "white",
    },
    80: { name: "B", color: "yellow darken-3", avatar_color: "lime lighten-4" },
    90: {
      name: "B+",
      color: "yellow darken-2",
      avatar_color: "lime lighten-4",
    },
    100: {
      name: "BB-",
      color: "yellow darken-1",
      avatar_color: "lime lighten-4",
    },
    110: {
      name: "BB",
      color: "yellow lighten-1",
      avatar_color: "lime lighten-1",
    },
    120: {
      name: "BB+",
      color: "yellow lighten-2",
      avatar_color: "lime lighten-1",
    },
    130: {
      name: "BBB-",
      color: "yellow lighten-3",
      avatar_color: "lime lighten-1",
    },
    140: {
      name: "BBB",
      color: "yellow lighten-4",
      avatar_color: "lime lighten-1",
    },
    150: {
      name: "BBB+",
      color: "yellow lighten-5",
      avatar_color: "lime lighten-1",
    },

    160: {
      name: "A-",
      color: "green darken-3",
      avatar_color: "lime darken-2",
      text: "white",
    },
    170: { name: "A", color: "green darken-2", avatar_color: "lime lighten-1" },
    180: {
      name: "A+",
      color: "green darken-1",
      avatar_color: "lime lighten-1",
    },
    190: {
      name: "AA-",
      color: "green lighten-1",
      avatar_color: "lime lighten-1",
    },
    200: {
      name: "AA",
      color: "green lighten-2",
      avatar_color: "lime lighten-1",
      text: "white",
    },
    210: {
      name: "AA+",
      color: "green lighten-3",
      avatar_color: "lime lighten-4",
    },
    220: {
      name: "AAA",
      color: "green lighten-4",
      avatar_color: "light-green darken-1",
    },
  },

  siteRecall: {
    1: {
      name: i18n.t("utilsData.statuses.siteRecall.1"),
      color: "green",
      text: "white",
    },
  },

  1: {
    name: i18n.t("utilsData.statuses.bids.1"),
  },
  2: {
    name: i18n.t("utilsData.statuses.bids.2"),
  },
  3: {
    name: i18n.t("utilsData.statuses.bids.3"),
  },
  4: {
    name: i18n.t("utilsData.statuses.bids.4"),
  },
  5: {
    name: i18n.t("utilsData.statuses.bids.5"),
  },

  leads: {
    0: {
      name: i18n.t("utilsData.statuses.leads.0"),
      color: "gray",
      text: "black",
    },
    1: {
      name: i18n.t("utilsData.statuses.leads.1"),
      color: "blue",
      text: "white",
    },
    2: {
      name: i18n.t("utilsData.statuses.leads.2"),
      color: "orange",
      text: "white",
    },
    5: {
      name: i18n.t("utilsData.statuses.leads.5"),
      color: "red",
      text: "white",
    },
  },

  split: {
    genderList: {
      1: { name: i18n.t("utilsData.statuses.split.genderList.1") },
      2: { name: i18n.t("utilsData.statuses.split.genderList.2") },
    },

    payoutTypeList: {
      1: { name: i18n.t("utilsData.statuses.split.payoutTypeList.1") },
      2: { name: i18n.t("utilsData.statuses.split.payoutTypeList.2") },
      4: { name: i18n.t("utilsData.statuses.split.payoutTypeList.4") },
    },

    tarifList: {
      1: { name: i18n.t("utilsData.statuses.split.tarifList.1") },
      2: { name: i18n.t("utilsData.statuses.split.tarifList.2") },
      3: { name: "33333" },
      4: { name: "33344433" },
    },

    statuses: {
      bids: {
        5: {
          name: i18n.t("utilsData.statuses.split.statuses.bids.5"),
          color: "red",
          text: "white",
        },
        10: {
          name: i18n.t("utilsData.statuses.split.statuses.bids.10"),
          color: "gray",
          text: "black",
        },
        20: {
          name: i18n.t("utilsData.statuses.split.statuses.bids.20"),
          color: "green lighten-3",
          text: "white",
        },
        30: {
          name: i18n.t("utilsData.statuses.split.statuses.bids.30"),
          color: "orange lighten-3",
          text: "white",
        },
        40: {
          name: i18n.t("utilsData.statuses.split.statuses.bids.40"),
          color: "green darken-3",
          text: "white",
        },
        100: {
          name: i18n.t("utilsData.statuses.split.statuses.bids.100"),
          color: "purple darken-2",
          text: "white",
        },
      },
    },

    transaction: {
      status: {
        10: { name: i18n.t("utilsData.statuses.split.transaction.status.10") },
        20: { name: i18n.t("utilsData.statuses.split.transaction.status.20") },
        30: { name: i18n.t("utilsData.statuses.split.transaction.status.30") },
        50: { name: i18n.t("utilsData.statuses.split.transaction.status.50") },
      },
      type: {
        1: { name: i18n.t("utilsData.statuses.split.transaction.type.1") },
        2: { name: i18n.t("utilsData.statuses.split.transaction.type.2") },
      },
    },
  },
};
